import {
	axiosErrorHandler,
	get,
	post,
	put,
} from 'models/shared/helpers/axiosInstance';
import { PaginatedDocuments } from 'models/shared/types/pagination';
import { buildPathWithQueryParams } from 'models/shared/helpers/utils';
import { imagesDto } from 'models/inventory/interfaces/vehicle.interface';
import {
	CreateExternalVehicleDto,
	ExternalVehicle,
	ExternalVehicleFilterDto,
	UpdateExternalVehicleDto,
} from '../interfaces/external-vehicles.interface';

const baseVehiclePath = '/v1/external-vehicles';

export const fetchExternalVehicles = async (dto: ExternalVehicleFilterDto) => {
	try {
		const res = await get<PaginatedDocuments<ExternalVehicle>>(
			buildPathWithQueryParams(baseVehiclePath, dto),
		);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const fetchExternalVehicle = async (id: string) => {
	try {
		const url = `${baseVehiclePath}/${id}`;
		const res = await get<ExternalVehicle>(url);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const fetchExternalVehicleByInternalId = async (internalId: string) => {
	try {
		const url = `${baseVehiclePath}/internal-id/${internalId}`;
		const res = await get<ExternalVehicle>(url);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const fetchExternalVehicleByTile = async (tileId: string) => {
	try {
		const url = `${baseVehiclePath}/tile/${tileId}`;
		const res = await get<ExternalVehicle>(url);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const createExternalVehicle = async (
	values: CreateExternalVehicleDto,
	image?: imagesDto,
) => {
	try {
		const data = new FormData();
		if (image) {
			data.append('image', image.file);
		}

		Object.keys(values).forEach((k) => {
			const value = values[k as keyof CreateExternalVehicleDto];
			if (value !== undefined) {
				data.append(k, value as string);
			}
		});
		const res = await post<ExternalVehicle>(`${baseVehiclePath}`, data, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const updateExternalVehicle = async (
	values: UpdateExternalVehicleDto,
	id: string,
	image?: imagesDto,
) => {
	try {
		const data = new FormData();
		if (image?.file) {
			data.append('image', image.file);
		}

		Object.keys(values).forEach((k) => {
			const value = values[k as keyof UpdateExternalVehicleDto];
			if (value !== undefined) {
				data.append(k, value as string);
			}
		});
		const res = await put<ExternalVehicle>(`${baseVehiclePath}/${id}`, data, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
